import { useContext } from "react";
import { PayPalButton } from "react-paypal-button-v2";
import { SettingsContext, CartContext, ShopContext } from "../../App";

function Paypal({ onPayment }) {
	const { validateCartBeforeCheckout } = useContext(SettingsContext);
	const { shop } = useContext(ShopContext);
	const { cart } = useContext(CartContext);

	return (
		<PayPalButton
			amount={cart.total}
			shippingPreference="NO_SHIPPING"
			currency="EUR"
			options={{
				clientId:
					shop.payment_methods[3].environment == "sandbox"
						? shop.payment_methods[3].sandbox_client_id
						: shop.payment_methods[3].production_client_id,
				currency: "EUR",
				disableFunding: "card",
			}}
			createOrder={async (data, actions) => {
				const isOk = await validateCartBeforeCheckout();
				if (!isOk) throw new Error("Cart validation failed");
				return actions.order.create({
					purchase_units: [
						{
							amount: {
								currency_code: "EUR",
								value: String(cart.total),
							},
						},
					],
					application_context: {
						shipping_preference: "NO_SHIPPING",
					},
				});
			}}
			onSuccess={(details, data) => {
				console.log(details);
				console.log(data);
				onPayment(3, details.id);
			}}
		/>
	);
}

export default Paypal;
